import React from 'react';
import BreadcrumbContext from './BreadcrumbContext';
import withBreadcrumbs from '../withBreadcrumbs';
class AnchorsContent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            depth: 0,
            anchors: [],
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { depth, anchors } = prevState;
        const { depth: nextDepth, anchors: nextAnchors } = nextProps;
        if (depth !== nextDepth || anchors !== nextAnchors) {
            return { depth: nextDepth, anchors: nextAnchors || [] };
        }
        return null;
    }
    componentDidMount() {
        const { depth, anchors } = this.state;
        const { addAnchors, getTitle, getRoute } = this.props;
        addAnchors(depth, mapAnchors(anchors, { getTitle, getRoute }));
    }
    componentDidUpdate(prevProps, prevState) {
        const { addAnchors, removeAnchors, getTitle, getRoute } = this.props;
        const { depth, anchors } = this.state;
        const { getRoute: prevGetRoute } = prevProps;
        const { depth: prevDepth, anchors: prevAnchors } = prevState;
        if (depth !== prevDepth || anchors !== prevAnchors) {
            removeAnchors(extractRoutes(prevAnchors, {
                getRoute: prevGetRoute,
            }));
            addAnchors(depth, mapAnchors(anchors, { getTitle, getRoute }));
        }
    }
    componentWillUnmount() {
        const { removeAnchors, getRoute } = this.props;
        const { anchors } = this.state;
        removeAnchors(extractRoutes(anchors, { getRoute }));
    }
    render() {
        const { children } = this.props;
        const { depth, anchors } = this.state;
        // TechDebt: "isLoading" is ignored here.
        // Maybe one day we'll want to show a spinner in breadcrumbs
        return (<BreadcrumbContext.Provider value={{ depth: depth + anchors.length }}>
        {children}
      </BreadcrumbContext.Provider>);
    }
}
export default withBreadcrumbs(AnchorsContent);
function mapAnchors(objects, { getTitle, getRoute }) {
    return objects.map(o => ({
        title: getTitle(o),
        route: getRoute(o),
    }));
}
function extractRoutes(objects, { getRoute }) {
    return objects.map(getRoute);
}
